import { createFileRoute } from '@tanstack/react-router';

import { useNavState } from '@/lib/nav-state';
import { ForgotPasswordScreen } from '@/screens/auth/ForgotPasswordScreen';

/** A typed-in address travels in history state, never in the URL. */
export const Route = createFileRoute('/_auth/forgot-password')({
  component: ForgotPasswordRoute,
});

function ForgotPasswordRoute() {
  const { email } = useNavState();
  return <ForgotPasswordScreen email={email} />;
}
